var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4247_7910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66659 13.3334C2.29992 13.3334 1.98614 13.203 1.72525 12.9421C1.46392 12.6807 1.33325 12.3667 1.33325 12.0001V4.00008C1.33325 3.63341 1.46392 3.31964 1.72525 3.05875C1.98614 2.79741 2.29992 2.66675 2.66659 2.66675H10.6666C11.0333 2.66675 11.3473 2.79741 11.6086 3.05875C11.8695 3.31964 11.9999 3.63341 11.9999 4.00008V7.00008L14.0999 4.90008C14.211 4.78897 14.3333 4.76119 14.4666 4.81675C14.5999 4.8723 14.6666 4.97786 14.6666 5.13341V10.8667C14.6666 11.0223 14.5999 11.1279 14.4666 11.1834C14.3333 11.239 14.211 11.2112 14.0999 11.1001L11.9999 9.00008V12.0001C11.9999 12.3667 11.8695 12.6807 11.6086 12.9421C11.3473 13.203 11.0333 13.3334 10.6666 13.3334H2.66659ZM2.66659 12.0001H10.6666V4.00008H2.66659V12.0001Z",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.2bf9acf17766c2b0bfaf8562b59c0917.svg";
export { ForwardRef as ReactComponent };